import { E_Routes } from '../enums/E_Routes';

type T_LastPart<T extends string> = T extends `${string}/${infer U}` ? U : T;

type T_RouteNames = T_LastPart<E_Routes>;

export const C_Routes = Object.values(E_Routes).reduce(
  (acc, route) => {
    const name = (
      route.includes('/') ? route.split('/').pop()! : route
    ) as T_RouteNames;

    acc[route] = {
      name,
      link: `/${route !== E_Routes.HOME ? route : ''}`
    };

    return acc;
  },
  {} as Record<E_Routes, { name: T_RouteNames; link: `/${E_Routes}` | '/' }>
);

export const C_DEFAULT_404_POOL_LINK = '/pools/btc';
